module.exports = __webpack_public_path__ + "media/images/illustration/undraw_sweet_home_dkhr-2ae3ef3b300c1ccaf982157511bc56e1.svg";